/**
 * Cookie names used in the application
 */
export const CSRF_TOKEN_COOKIE = "csrftoken";
export const QA_AUTH_TOKEN_COOKIE = "qa-auth-token";

/**
 * Sets a cookie on the current origin (e.g. localhost).
 */
export const setCookie = (
  name: string,
  value: string,
  options: { path?: string; maxAgeSeconds?: number } = {},
): void => {
  const { path = "/", maxAgeSeconds = 86400 * 7 } = options;
  const encoded = encodeURIComponent(value);
  const maxAge = maxAgeSeconds > 0 ? `; max-age=${maxAgeSeconds}` : "";
  document.cookie = `${name}=${encoded}; path=${path}${maxAge}; SameSite=Lax`;
};

/**
 * Gets a cookie value by name
 */
export const getCookie = (cookieName: string): string | null => {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const trimmedCookie = cookie.trim();
    const equalsIndex = trimmedCookie.indexOf("=");

    if (equalsIndex === -1) {
      continue;
    }

    const name = trimmedCookie.substring(0, equalsIndex);
    const value = trimmedCookie.substring(equalsIndex + 1);

    if (name === cookieName) {
      return decodeURIComponent(value);
    }
  }
  return null;
};
